import { Value } from '@philips-internal/oswald-ui-core';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services';

type AsyncFunction <A extends Array<Value>,O> = (...args:A) => Promise<O>;

const historyService = HistoryService;

export class RouteError extends Error {
  constructor(m: string) {
    super(m);
    Object.setPrototypeOf(this, RouteError.prototype);
  }
}

export default class RouteUtils {

  /**
   * Wraps an async function to throw an error if the route changes before the promise is resolved
   * @param fn AsyncFunction
   * @returns AsyncFunction
   */
  static routeSafeAsync<Args extends Value[], Out>(fn: AsyncFunction<Args, Out>): AsyncFunction<Args, Out> {
    const controllerRoute = historyService.getCurrentRoute();

    return async function(...args: Args) {
      const result = await fn(...args);
      const currentRoute = historyService.getCurrentRoute();

      if(controllerRoute !== currentRoute){
        throw new RouteError('Route changed before promise resolve');
      }

      return result;
    }
  }
}